(function () {
  if (!window.HbElements) return;

  class HbAnnouncementBar extends HbElements.Component {
    onConnect() {
      this.key = this.dataset.storageKey || 'hb-announcement-dismissed';
      try {
        if (sessionStorage.getItem(this.key)) {
          this.hidden = true;
          return;
        }
      } catch (error) {
        /* private mode */
      }
      this.onDismiss = this.onDismiss.bind(this);
      this.button = this.querySelector('[data-announcement-dismiss]');
      if (this.button) this.button.addEventListener('click', this.onDismiss);
    }

    onDisconnect() {
      if (this.button && this.onDismiss) this.button.removeEventListener('click', this.onDismiss);
    }

    onDismiss() {
      try {
        sessionStorage.setItem(this.key, '1');
      } catch (error) {
        /* private mode */
      }
      this.hidden = true;
    }
  }

  HbElements.define('hb-announcement-bar', HbAnnouncementBar);
})();
